import { render } from "./filter-s3.vue?vue&type=template&id=006a884f&scoped=true"
import script from "./filter-s3.vue?vue&type=script&lang=js"
export * from "./filter-s3.vue?vue&type=script&lang=js"

import "./filter-s3.vue?vue&type=style&index=0&id=006a884f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006a884f"]])

export default __exports__